import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTransactionListPageUI from './ClientTransactionListPageUI.js'
import { getFinancialYearList } from '../../../components/common/GetYearList'
import LocalStorageKeys from '../../../cache/LocalStorageKeys'

class ClientTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    const { financialYearList, financialYear } = getFinancialYearList()
    this.state = {
      errorList: null,
      // displayed data
      txnList: null,
      filteredTxnList: null,
      bankAccountList: null,
      financialYear: financialYear,
      financialYearList: financialYearList,
      bankAccountNumber: null,
      //
      copyToClipboardText: null,
      // filter
      searchFilter: '',
      // pagination
      lastKey: null,
      hasMore: true,
      gettingMore: false,
      // category update
      selectedTxn: null,
      categoryUpdateMode: false,
      categoryList: [],
      //dedupliaction
      deduplicateSuccessMessage: null,
      deduplicateErrorList: [],
      deduplicationSubmitted: false,
    }
  }

  render() {
    
    return (
      <ClientTransactionListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        txnList={this.state.txnList}
        filteredTxnList={this.state.filteredTxnList}
        bankAccountList={this.state.bankAccountList}
        onRefreshClick={this.onRefreshClick}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        // filter
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // pagination
        hasMore={this.state.hasMore}
        onMoreTransactions={this.onMoreTransactions}
        gettingMore={this.state.gettingMore}
        //
        bankAccountNumber={this.state.bankAccountNumber}
        financialYearList={this.state.financialYearList}
        financialYear={this.state.financialYear}
        onFinancialYearChange={this.onFinancialYearChange}
        //
        selectedTxn={this.state.selectedTxn}
        categoryList={this.state.categoryList}
        categoryUpdateMode={this.state.categoryUpdateMode}
        onCategoryUpdateClick={this.onCategoryUpdateClick}
        onCancelUpdateClick={() => { this.setState({ categoryUpdateMode: false }) }}
        //
        onDeduplicateClick={this.onDeduplicateClick}
        deduplicateSuccessMessage={this.state.deduplicateSuccessMessage}
        deduplicateErrorList={this.state.deduplicateErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getClientAccounts(context)
    this.getBankAnalyzerCategories(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.bankAccountId == this.props.match.params.bankAccountId)
      return

    let context = this.props.context
    this.getClientAccounts(context)
  }

  getClientAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/clientBankAccounts/info`,
      cacheKey: CacheKeys.ClientBankAccounts(this.props.match.params.accountId),
      callback: this.getClientAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getClientAccountsCallback = (response) => {
    let bankAccountNumber = this.props.match.params.bankAccountId
    if (!bankAccountNumber)
      bankAccountNumber = response.bankAccountList.length ? response.bankAccountList[0].bankAccountNumber : ''

    this.setState(
      {
        bankAccountList: response.bankAccountList,
        bankAccountNumber: bankAccountNumber,
        errorList: response.errorList
      }, () => {
        if (bankAccountNumber != '') {
          this.getTransactions(this.props.context, bankAccountNumber, this.state.financialYear)
        }
      }
    )
  }

  getTransactions(context, bankAccountNumber, financialYear) {
    //this.setState({txnList: null})
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/clientBankAccounts/${bankAccountNumber}/transactions`,
      cacheKey: CacheKeys.ClientTransactions(bankAccountNumber, financialYear),
      callback: this.getTransactionsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context, null,
      {
        financialYear: financialYear,
        limit: 100,
      }
    )
  }

  getTransactionsCallback = (response) => {
    let bankAccountNumber = this.state.bankAccountNumber

    let filtersStr = sessionStorage.getItem(CacheKeys.ClientTransactionsFilter(this.props.match.params.accountId, bankAccountNumber))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      financialYear: response.financialYear,
      // filteredTxnList: response.transactionList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      lastKey: response.lastKey,
      hasMore: response.hasMore
    })

    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '')
  }

  onMoreTransactions = () => {
    let bankAccountNumber = this.state.bankAccountNumber

    let context = this.props.context
    this.setState({ gettingMore: true })

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/clientBankAccounts/${bankAccountNumber}/transactions`,
      cacheKey: CacheKeys.ClientTransactions(bankAccountNumber, this.state.financialYear),
      callback: this.onMoreTransactionsCallback,
      ttlInSecs: 0
    })

    let limit = 1000
    if (this.state.txnList.length === 100)
      limit = 900
    cacheManager.getObject2(context, null,
      {
        financialYear: this.state.financialYear,
        limit: limit,
        evaluatedKey: this.state.lastKey
      }
    )
  }

  onMoreTransactionsCallback = (response) => {
    let context = this.props.context
    let txnList = this.state.txnList
    response.transactionList = txnList.concat(response.transactionList)

    // let filtersStr = sessionStorage.getItem(CacheKeys.ClientTransactionsFilter(this.props.match.params.accountId, this.props.match.params.bankAccountId))
    // let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      // filteredTxnList: response.transactionList,
      // searchFilter: filters.searchFilter ? filters.searchFilter : '',
      currentPage: response.currentPage,
      lastKey: response.lastKey,
      hasMore: response.hasMore,
      gettingMore: false
    })

    this.applyFilters(response.transactionList, this.state.searchFilter)
  }

  onFinancialYearChange = (option) => {
    let context = this.props.context
    this.setState({ financialYear: option.value })
    this.getTransactions(context, this.state.bankAccountNumber, option.value)
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  applyFilters(txnList, searchFilter) {
    let bankAccountNumber = this.props.match.params.bankAccountId || this.state.bankAccountList[0].bankAccountNumber

    let filteredList = txnList

    if (searchFilter)
      filteredList = filteredList.filter(txn =>
        txn.narration.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        txn.paymentCategory.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({ filteredTxnList: filteredList })

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.ClientTransactionsFilter(this.props.match.params.accountId, bankAccountNumber), JSON.stringify(filters))
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getBankAnalyzerCategories(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/bankAnalyzerCategories`,
      cacheKey: CacheKeys.BankAnalyzerCategories(),
      callback: this.getBankAnalyzerCategoriesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getBankAnalyzerCategoriesCallback = (response) => {
    let mappedValueList = response.codeLabelList.map(cat => ({ key: cat.code, value: cat.label }))
    this.setState({
      categoryList: mappedValueList,
    })
  }

  onCategoryUpdateClick = (event) => {
    let selectedTxnId = event.currentTarget.getAttribute('data-txnid')
    let selectedTxn = this.state.txnList.filter(t => t.transactionId === selectedTxnId)[0]
    this.setState({
      selectedTxn: selectedTxn,
      categoryUpdateMode: true
    })
  }

  onDeduplicateClick = () => {
    let deduplicationSubmitted = this.state.deduplicationSubmitted;
    if (deduplicationSubmitted) return;

    this.setState({
      deduplicateSuccessMessage: null,
      deduplicateErrorList: [],
      deduplicationSubmitted: true,
    });

    const { accountId } = this.props.match.params;
    const apiUrl = `/api/su/dataFix/accounts/${accountId}/clientTxns/deDuplication`;

    RestApiUtils.put(this.props.context, apiUrl, this.onDeduplicationCallback, {});
  }

  onDeduplicationCallback = (response) => {
    let deduplicateErrorList = [];
    response.errorList.forEach(error => {
      deduplicateErrorList.push(error.message);
    });

    this.setState({
      deduplicateSuccessMessage: response.success,
      deduplicateErrorList: deduplicateErrorList,
      deduplicationSubmitted: false,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ deduplicateSuccessMessage: null });
        this.onRefreshClick();
      }, 2000);
    }
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.ClientBankAccounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.ClientTransactions(this.state.bankAccountNumber, this.state.financialYear))
    CacheManager.removeObject(CacheKeys.AccountProperty(this.props.match.params.accountId, 'internal_transfer_keywords'))
    CacheManager.removeObject(CacheKeys.BankAnalyzerCategories())

    let context = this.props.context

    if (noBusy === 'noBusy') {
      console.log('noBusy');
      this.getClientAccounts(context)
    }
    else {
      console.log('Busy');
      this.setState({
        errorList: null,
        txnList: null,
        filteredTxnList: null,
      }, () => {
        this.getClientAccounts(context)
      })
    }
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.txnList, searchFilter)
  }
}

export default withRouter(ClientTransactionListPageSF)
